// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MutationHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["mutation StudentResponsePartialPointsFunction($studentActivityAttemptId: uuid, $answer: String, $responsesCorrect: Int, $responsesComplete: Int, $points: Int, $questionIndex: Int, $state: String, $contentMd5: String)  {\nresponse: student_response_partial_points_function(args: {student_activity_attemptid: $studentActivityAttemptId, answer: $answer, responses_correct: $responsesCorrect, responses_complete: $responsesComplete, points: $points, question_index: $questionIndex, state: $state, content_md_5: $contentMd5})  {\n__typename  \nid  \nstudentActivityAttemptId  \nquestionIndex  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.response;
  return {
          response: value$1.map(function (value) {
                return {
                        __typename: value.__typename,
                        id: value.id,
                        studentActivityAttemptId: value.studentActivityAttemptId,
                        questionIndex: value.questionIndex
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.response;
  var response = value$1.map(function (value) {
        var value$1 = value.questionIndex;
        var value$2 = value.studentActivityAttemptId;
        var value$3 = value.id;
        var value$4 = value.__typename;
        return {
                __typename: value$4,
                id: value$3,
                studentActivityAttemptId: value$2,
                questionIndex: value$1
              };
      });
  return {
          response: response
        };
}

function serializeVariables(inp) {
  var a = inp.studentActivityAttemptId;
  var a$1 = inp.answer;
  var a$2 = inp.responsesCorrect;
  var a$3 = inp.responsesComplete;
  var a$4 = inp.points;
  var a$5 = inp.questionIndex;
  var a$6 = inp.state;
  var a$7 = inp.contentMd5;
  return {
          studentActivityAttemptId: a !== undefined ? a : undefined,
          answer: a$1 !== undefined ? a$1 : undefined,
          responsesCorrect: a$2 !== undefined ? a$2 : undefined,
          responsesComplete: a$3 !== undefined ? a$3 : undefined,
          points: a$4 !== undefined ? a$4 : undefined,
          questionIndex: a$5 !== undefined ? a$5 : undefined,
          state: a$6 !== undefined ? a$6 : undefined,
          contentMd5: a$7 !== undefined ? a$7 : undefined
        };
}

function makeVariables(studentActivityAttemptId, answer, responsesCorrect, responsesComplete, points, questionIndex, state, contentMd5, param) {
  return {
          studentActivityAttemptId: studentActivityAttemptId,
          answer: answer,
          responsesCorrect: responsesCorrect,
          responsesComplete: responsesComplete,
          points: points,
          questionIndex: questionIndex,
          state: state,
          contentMd5: contentMd5
        };
}

function makeDefaultVariables(param) {
  return {
          studentActivityAttemptId: undefined,
          answer: undefined,
          responsesCorrect: undefined,
          responsesComplete: undefined,
          points: undefined,
          questionIndex: undefined,
          state: undefined,
          contentMd5: undefined
        };
}

var StudentResponsePartialPointsFunction_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var StudentResponsePartialPointsFunction = {
  StudentResponsePartialPointsFunction_inner: StudentResponsePartialPointsFunction_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  use: use,
  useWithState: useWithState
};

var StudentResponsePartialPoints = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

var StudentResponsePartialPointsMutationFailed = /* @__PURE__ */Caml_exceptions.create("StudentResponseMutation-LiteracyplanetClientLibsActivity.StudentResponsePartialPointsMutationFailed");

function useFetchPartialPoints(param) {
  var mutate = Curry._1(StudentResponsePartialPoints.useAsync, "StudentResponsePartialPoints.useFetchPartialPoints");
  return async function (studentActivityAttemptId, answer, responsesCorrect, responsesComplete, points, questionIndex, state, contentMd5) {
    var match = await Curry._1(mutate, {
          studentActivityAttemptId: HasuraTypes$LiteracyplanetClientFlags.encode(studentActivityAttemptId),
          answer: answer,
          responsesCorrect: responsesCorrect,
          responsesComplete: responsesComplete,
          points: points,
          questionIndex: questionIndex,
          state: state,
          contentMd5: contentMd5
        });
    var data = match.data;
    if (data !== undefined) {
      if (data.response.length !== 1) {
        throw {
              RE_EXN_ID: StudentResponsePartialPointsMutationFailed,
              Error: new Error()
            };
      }
      return ;
    }
    throw {
          RE_EXN_ID: StudentResponsePartialPointsMutationFailed,
          Error: new Error()
        };
  };
}

var StudentResponseMutationFailed = /* @__PURE__ */Caml_exceptions.create("StudentResponseMutation-LiteracyplanetClientLibsActivity.StudentResponseMutationFailed");

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["mutation StudentResponseFunction($studentActivityAttemptId: uuid, $answer: String, $points: Int, $questionIndex: Int, $state: String, $contentMd5: String)  {\nresponse: student_response_function(args: {student_activity_attemptid: $studentActivityAttemptId, answer: $answer, points: $points, question_index: $questionIndex, state: $state, content_md_5: $contentMd5})  {\n__typename  \nid  \nstudentActivityAttemptId  \nquestionIndex  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.response;
  return {
          response: value$1.map(function (value) {
                return {
                        __typename: value.__typename,
                        id: value.id,
                        studentActivityAttemptId: value.studentActivityAttemptId,
                        questionIndex: value.questionIndex
                      };
              })
        };
}

function serialize$1(value) {
  var value$1 = value.response;
  var response = value$1.map(function (value) {
        var value$1 = value.questionIndex;
        var value$2 = value.studentActivityAttemptId;
        var value$3 = value.id;
        var value$4 = value.__typename;
        return {
                __typename: value$4,
                id: value$3,
                studentActivityAttemptId: value$2,
                questionIndex: value$1
              };
      });
  return {
          response: response
        };
}

function serializeVariables$1(inp) {
  var a = inp.studentActivityAttemptId;
  var a$1 = inp.answer;
  var a$2 = inp.points;
  var a$3 = inp.questionIndex;
  var a$4 = inp.state;
  var a$5 = inp.contentMd5;
  return {
          studentActivityAttemptId: a !== undefined ? a : undefined,
          answer: a$1 !== undefined ? a$1 : undefined,
          points: a$2 !== undefined ? a$2 : undefined,
          questionIndex: a$3 !== undefined ? a$3 : undefined,
          state: a$4 !== undefined ? a$4 : undefined,
          contentMd5: a$5 !== undefined ? a$5 : undefined
        };
}

function makeVariables$1(studentActivityAttemptId, answer, points, questionIndex, state, contentMd5, param) {
  return {
          studentActivityAttemptId: studentActivityAttemptId,
          answer: answer,
          points: points,
          questionIndex: questionIndex,
          state: state,
          contentMd5: contentMd5
        };
}

function makeDefaultVariables$1(param) {
  return {
          studentActivityAttemptId: undefined,
          answer: undefined,
          points: undefined,
          questionIndex: undefined,
          state: undefined,
          contentMd5: undefined
        };
}

var StudentResponseFunction_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useWithState$1 = include$1.useWithState;

var StudentResponseFunction = {
  StudentResponseFunction_inner: StudentResponseFunction_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  makeDefaultVariables: makeDefaultVariables$1,
  use: use$1,
  useWithState: useWithState$1
};

var StudentResponse = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useWithState: useWithState$1
    });

function useFetchFullPoints(param) {
  var mutate = Curry._1(StudentResponse.useAsync, "StudentResponseFunction.useFetchFullPoints");
  return async function (studentActivityAttemptId, answer, points, questionIndex, state, contentMd5) {
    var match = await Curry._1(mutate, {
          studentActivityAttemptId: HasuraTypes$LiteracyplanetClientFlags.encode(studentActivityAttemptId),
          answer: answer,
          points: points,
          questionIndex: questionIndex,
          state: state,
          contentMd5: contentMd5
        });
    var data = match.data;
    if (data !== undefined) {
      if (data.response.length !== 1) {
        throw {
              RE_EXN_ID: StudentResponseMutationFailed,
              Error: new Error()
            };
      }
      return ;
    }
    throw {
          RE_EXN_ID: StudentResponseMutationFailed,
          Error: new Error()
        };
  };
}

function use$2(param) {
  var match = Curry._1(StudentResponse.useWithWordMonsterError, "student_response_function");
  var mutation = match[0];
  var insert = function (studentActivityAttemptId, answer, points, questionIndex, state, contentMd5) {
    Curry._1(mutation, {
          studentActivityAttemptId: HasuraTypes$LiteracyplanetClientFlags.encode(studentActivityAttemptId),
          answer: answer,
          points: points,
          questionIndex: questionIndex,
          state: state,
          contentMd5: contentMd5
        });
  };
  return [
          insert,
          Belt_Option.flatMap(match[3], (function (param) {
                  return Belt_Option.map(Belt_Array.get(param.response, 0), (function (r) {
                                return HasuraTypes$LiteracyplanetClientFlags.decode(r.id);
                              }));
                }))
        ];
}

export {
  StudentResponsePartialPointsFunction ,
  StudentResponsePartialPoints ,
  StudentResponsePartialPointsMutationFailed ,
  useFetchPartialPoints ,
  StudentResponseMutationFailed ,
  StudentResponseFunction ,
  StudentResponse ,
  useFetchFullPoints ,
  use$2 as use,
}
/* query Not a pure module */
